<div class="banner-wrapper" [class.arebic-content]="textDirection == 'rtl'">

    <div class="arrow-mobile-banner">
        <img src="assets/images/light-blue-union.svg" />
      </div>
    <div class="arrow-m">
      <img src="assets/images/light-blue-m.svg" />
    </div>
    <div class="banner-heading">
        <h1 [innerHTML]="'HOME_PAGE.BANNER_TITLE' | translate"></h1>
        <span translate>
            HOME_PAGE.SARIA_COMPLAINT
        </span>       
        <a [href]="appLink" target="_blank">
            <img class="app-store-icon" [src]="appIcon">
        </a>  
    </div>
    <div class="download-qr">
        <a [href]="appLink" target="_blank">
            <img src="assets/images/download-qr.svg" alt="QR Code">
        </a> 
        <span translate>HOME_PAGE.FREE_APP</span>
    </div>

    <div class="arrow">
        <img src="assets/images/light-blue-union.svg" />
    </div>


</div>